import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MobileDrawerService {
  private readonly openSubject = new Subject<void>();

  public readonly open$: Observable<void> = this.openSubject.asObservable();

  public open(): void {
    this.openSubject.next();
  }
}
